var exports = {
  "kL": "xe7b6e3d6--49e6d6--container",
  "pq": "xe7b6e3d6--49e6d6--info",
  "Kk": "xe7b6e3d6--49e6d6--icon",
};

module.exports = exports;
